import React from "react"

import { BuildingType } from "shared/types/references/BuildingType"
import { RoomType } from "shared/types/references/RoomType"

import { ProductSelectOption } from "entities/products/types/ProductSelectOption"

import { ReferenceFilterChipListView } from "./ReferenceFilterChipListView"
import { useReferenceFilterChipListViewModel } from "./model/useReferenceFilterChipListViewModel"

export interface ReferenceFilterChipListState {
  products?: string[] | null
  buildingTypes?: BuildingType[] | null
  roomTypes?: RoomType[] | null
}

export interface ReferenceFilterChipListProps<
  T extends ReferenceFilterChipListState = ReferenceFilterChipListState
> {
  filterState: T
  onChange: (state: T) => void
  productOptions?: ProductSelectOption[]
}

export const ReferenceFilterChipList = React.memo(
  <T extends ReferenceFilterChipListState>(
    props: ReferenceFilterChipListProps<T>
  ) => (
    <ReferenceFilterChipListView
      {...useReferenceFilterChipListViewModel(props)}
    />
  )
) as <T extends ReferenceFilterChipListState>(
  props: ReferenceFilterChipListProps<T>
) => React.ReactElement | null
;(ReferenceFilterChipList as React.MemoExoticComponent<React.FC>).displayName =
  "ReferenceFilterChipList"
